import PropTypes from 'prop-types';
import LoadingRobot from 'core/modules/atoms/LoadingRobot';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import FormField from 'ui/molecules/FormField/FormField';
import TextArea from 'ui/atoms/TextArea/TextArea';
import React from 'react';
import { withTranslation } from 'react-i18next';
import useDialogAIGeneratedActivity from './useDialogAIGeneratedActivity';

const DialogAIGeneratedActivity = ({ t, open, course, onClose, onSuccess }) => {
  const { loading, error, topic, onChangeTopic, onGenerate } = useDialogAIGeneratedActivity({ course, onSuccess });

  return (
    <Dialog
      title={t('template:AI-generated question')}
      isOpen={open}
      hasFooterBackground={true}
      onClose={onClose}
      onCancel={onClose}
      className="dialog-lemonade-templates"
      hasSeparator={true}
      isDisabledSuccess={loading || topic.length < 4}
      buttonTextSuccess={t('actions:Continue')}
      buttonTextCancel={t('actions:Cancel')}
      onSuccess={onGenerate}
    >
      <div className="dialog-lemonade-templates__wrapper">
        {loading ? (
          <div className="dialog-lemonade-templates__loading">
            <LoadingRobot loadingText={t("template:We're using artificial intelligence to create a new activity")} />
          </div>
        ) : (
          <div className="dialog-lemonade-templates__ai">
            <FormField
              error={!!error}
              errorMessage={t('template:There was a problem trying to generate your question')}
              label={t('template:Activity topic')}
            >
              <TextArea
                value={topic}
                onChange={({ target: { value } }) => onChangeTopic(value)}
                placeholder={t("template:Specify the subject or subjects you'd like your question to cover")}
              />
            </FormField>
          </div>
        )}
      </div>
    </Dialog>
  );
};

DialogAIGeneratedActivity.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

DialogAIGeneratedActivity.defaultProps = {};

export default withTranslation(['template', 'actions', 'lemonade'])(DialogAIGeneratedActivity);
